import type { ComponentType } from 'react';
import { CustomReportTitleRulesetEditor } from './CustomReportTitleRulesetEditor';
import { MagicEditRulesetEditor } from './MagicEditRulesetEditor';

export type RulesetEditorProps = {
  isDirtyRef?: React.MutableRefObject<boolean>;
};

/**
 * Returns the type-specific editor component. For FTIC, the caller must pass the FTIC editor
 * to avoid circular dependency (FTIC editor lives in RulesetEdit).
 */
export const getRulesetEditorComponent = (
  rulesetType: 'ftic' | 'magicEdit' | 'customReportTitle',
  fticEditor: ComponentType<RulesetEditorProps>,
): ComponentType<RulesetEditorProps> =>
  rulesetType === 'magicEdit'
    ? MagicEditRulesetEditor
    : rulesetType === 'customReportTitle'
      ? CustomReportTitleRulesetEditor
      : fticEditor;

export { CustomReportTitleRulesetEditor } from './CustomReportTitleRulesetEditor';
export { MagicEditRulesetEditor } from './MagicEditRulesetEditor';
